<!--
 * @Description: 
 * @Author: huangshiwen
 * @Date: 2022-06-13 17:27:34
-->
<template>
  <div class="tab" ref="editorDOM">
    <div class="m-main">
      <div class="pubctabs1 clear">
        <router-link
          v-for="(item, index) in ComponentDataConfig.list"
          :class="{now:currentIndex==index}"
          :key="index"
          :to="item.href"
          :rel="item.nofollow_href"
        >
          {{ item.title }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import config from "./config.js";

export default {
  name: "hospital-book-tab-001-sz",
   props:["currentIndex"],
  data() {
    return Object.assign(
      {
      },
      config
    );
  },
  mounted() {

  },
  methods: {}
};
</script>

<style lang="less" scoped>
.tab {
  background:#fff;
  .pubctabs1 {
    padding-top: 50px;
    display: flex;
  }
  .pubctabs1 a:first-child {
    margin-left: 0;
  }
  .pubctabs1 a {
    // float: left;
    // width: 232px;
    width: 18%;
    height: 57px;
    line-height: 57px;
    font-size: 18px;
    margin-left: 17px;
    text-align: center;
    box-shadow: 0px 1px 12px 0px #ccc;

    text-decoration: none;
    color: inherit;
  }
  .pubctabs1 a.now {
    background: #0078d4;
    color: #fff;
  }
}

.m-screen-pc {
}
.m-screen-mobile {
  padding: 0 0.25rem;
  .pubctabs1 {
    padding-top: 0.4rem;
    padding-bottom: 0.1rem;
    white-space: nowrap;
    overflow-x: auto;
  }
  .pubctabs1 a {
    float: none;
    display: inline-block;
    width: 2.6rem;
    height: 0.8rem;
    line-height: 0.8rem;
    font-size: 0.26rem;
    margin-left: 0.1rem;
  }
}
</style>
